/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2021-05-26 17:11:09
 */


/* eslint-disable global-require */

// The top-level (parent) route
export default {

  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [
    require('./homeform').default,
    require('./home').default,
    // require('./_about').default,
    // require('./privacy').default,
    // require('./admin').default,
    require('./dashboard').default,
    require('./homepage').default,
    require('./report').default,
    require('./solution').default,
    require('./mindshare').default,
    require('./top100').default,
    require('./soumi').default,
    require('./geo').default,
    require('./industry').default,
    require('./login').default,
    require('./platform').default,
    require('./register').default,
    require('./forgetpwd').default,
    require('./aboutus').default,
    require('./algorithm').default,
    require('./updateLog').default,
    require('./help').default,

    //后台管理界面
    require('./adminKOL').default,
    require('./adminBrand').default,
    require('./adminArticle').default,
    require('./adminAccount').default,
    require('./adminAccountInfo').default,
    require('./adminReport').default,
    
    require('./restore').default,

    require('./exportPDF').default,
    require('./customChart').default,
    require('./cms').default,
    require('./visualChart').default,
    
    // import(/* webpackChunkName: "exportPDF" */ './exportPDF'),
    // import(/* webpackChunkName: "customChart" */ './customChart'),
    // import(/* webpackChunkName: "cms" */ './cms'),
    require('./setRedisInfo').default,
    
    
    require('./devTest').default,

    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    require('./notFound').default
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || ''} - DBRank`;
    route.description = route.description || '';

    return route;
  },

};



// WEBPACK FOOTER //
// src/routes/index.js